import React, { useCallback, useEffect, useState } from 'react';
import EditIcon from '../../assets/EditIcon';
import Accordion from '../../components/common/Accordian';
import PaxPercentageBarSection from './PaxPercentageBarSection';
import { encodeDateForUrl } from '../../utils/dateUtils';
import operationAPI from '../../api/operationApi';
import { toast } from 'react-toastify';
import { translate } from '../../i18n';
import { IFlightDetails } from '../../type/flightDetails';
import useBgColorStore from '../../store/bgColor';
import BalloonIcon from '../../assets/BalloonIcon';
import PeopleIcon from '../../assets/PeopleIcon';
import BusIcons from '../../assets/BusIcons';
import LaunchingBalloons from '../../assets/LaunchingBalloons';
import LandingBalloon from '../../assets/LandingBalloon';
import AlarmClock from '../../assets/AlarmClock';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import FuelIcon from '../../assets/FuelIcon';
import RedLaunchingBalloons from '../../assets/RedLaunchingBalloons';
import RedLandingBalloons from '../../assets/RedLandingBalloons';
import EmptyFuelIcon from '../../assets/EmptyFuelIcon';
import Loader from '../../assets/loader/Loader';
import WeatherSection from './WeatherSection';
import { IFlightSectionProps } from '../../type/flightSectionProps';
import FlightTimeIcon from '../../assets/FlightTimeIcon';
import CancellationForm from '../common/FlightForm';
import { ICancellationReason } from '../../type/cancelReason';
import LaunchingBalloonsDark from '../../assets/LaunchingBalloonsDark';
import BalloonIconDark from '../../assets/BalloonIconDark';
import PeopleIconDark from '../../assets/PeopleIconDar';
import BusIconsDark from '../../assets/BusIconsDark';
import AlarmClockDark from '../../assets/AlarmClockDar';
import EmptyFuelIconDark from '../../assets/EmptyFuelIconDark';
import FuelIconDark from '../../assets/FuelIconDark';
import FlightTimeIconDark from '../../assets/FlightTimeIconDark';
import RedLandingBalloonsDark from '../../assets/RedLandingBalloonsDark';
import LandingBalloonDark from '../../assets/LandingBalloonDark';
import RedLaunchingBalloonsDark from '../../assets/RedLaunchingBalloonsDark';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import CalenderUpIcon from '../../assets/icon/CalenderUpIcon';
import EditIconDark from '../../assets/EditIconDark';
import { showOrReplaceToast } from '../../utils/utility';
import { CUSTOM_TOAST_ID } from '../../constants/constant';
import FlightCancelledModal from '../FlightCancelledModal';
import {
  useCancelReasons,
  useFlightDetails,
} from '../../hooks/apiHook/operationDetails';
import PeopleRedIcon from '../../assets/PeopleIconRed';

const FlightSections: React.FC<IFlightSectionProps> = ({
  selectedDate,
  ownerId,
  openModal,
  closeModal,
  pilotLoading,
  onPilotChangeRefetchTrigger,
}) => {
  const { bgColor } = useBgColorStore();
  const [flights, setFlights] = useState<IFlightDetails[]>();
  const [selectedFlightForCancel, setSelectedFlightForCancel] =
    useState<IFlightDetails | null>(null);
  const [selectedFlightForReactivation, setSelectedFlightForReactivation] =
    useState<IFlightDetails | null>(null);
  const [cancellationReasons, setCancellationReasons] = useState<
    ICancellationReason[]
  >([]);
  const [isEditWeather, setIsEditWeather] = useState<boolean>(false);
  useEffect(() => {
    if (pilotLoading) {
      refetchFlights();
    }
  }, [pilotLoading]);
  const {
    data: flightsData,
    isLoading: isFlightsLoading,
    refetch: refetchFlights,
  } = useFlightDetails(selectedDate, ownerId);

  useEffect(() => {
    refetchFlights();
  }, [onPilotChangeRefetchTrigger]);

  const { data: cancellationReasonList, isLoading: isCancelReasonsLoading } =
    useCancelReasons();

  useEffect(() => {
    if (flightsData) {
      setFlights(flightsData);
    }
  }, [flightsData]);

  useEffect(() => {
    if (cancellationReasonList) {
      setCancellationReasons(cancellationReasonList);
    }
  }, [cancellationReasonList]);

  const openUpdateModal = (flight: any) => {
    openModal('EditFormFlight', flight, () => {
      refetchFlights();
    });
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalFlight, setModalFlight] = useState<any>(null);
  const handleCheckboxClick = (
    e: React.ChangeEvent<HTMLInputElement>,
    flight: IFlightDetails,
  ) => {
    if (flight.cancelled) {
      e.preventDefault();
      setModalFlight(flight);
      setModalOpen(true);
      setSelectedFlightForReactivation(flight);
    } else {
      e.target.checked
        ? setSelectedFlightForCancel(flight)
        : setSelectedFlightForCancel(null);
    }
  };

  return (
    <Accordion
      title={`Flight`}
      icon={
        <div>
          <div className="block dark:hidden">
            <EditIcon onClick={() => setIsEditWeather(true)} />
          </div>
          <div className="hidden dark:block">
            <EditIconDark onClick={() => setIsEditWeather(true)} />
          </div>
        </div>
      }
      bgColor={bgColor}
      accordionIsOpen={true}
      iconOpen={
        <div>
          <div className="block dark:hidden">
            <AccordianDownIcon />
          </div>
          <div className="hidden dark:block">
            <AccordianDownIconDark />
          </div>
        </div>
      }
      iconClose={
        <div>
          <div className="block dark:hidden">
            <AccordianUpIcon />
          </div>
          <div className="hidden dark:block">
            <AccordianUpIconDark />
          </div>
        </div>
      }
    >
      <div className={` p-[4px] rounded-md`}>
        <WeatherSection
          selectedDate={selectedDate}
          ownerId={ownerId}
          isEditWeather={isEditWeather}
          setIsEditWeather={setIsEditWeather}
        />{' '}
        {isFlightsLoading ? (
          <div className="flex justify-center mt-5 mb-5">
            <Loader width={50} height={50} />
          </div>
        ) : flights?.length === 0 ? (
          <div>
            <p className="text-center p-4 h-[100px] text-lg font-semibold text-text-secondary">
              {translate('flightAllocation.noData')}
            </p>
          </div>
        ) : (
          <div>
            {flights?.map((flight: IFlightDetails) => {
            const allocatedPaxWeight = flight?.totalWeight ?? 0;
            const allocatedPilotWeight = flight?.pilotWeight ?? 0;
            const totalAllocatedWeight = allocatedPaxWeight + allocatedPilotWeight; 

              return (
                <>
                  <Accordion
                    key={flight?.operationBalloonId}
                    title={flight?.formattedBalloonName}
                    icon={
                      <div>
                        <div className="block dark:hidden">
                          <EditIcon
                            onClick={() => {
                              if (!flight.cancelled) {
                                openUpdateModal(flight);
                              }
                            }}
                          />
                        </div>
                        <div className="hidden dark:block">
                          <EditIconDark
                            onClick={() => {
                              if (!flight.cancelled) {
                                openUpdateModal(flight);
                              }
                            }}
                          />
                        </div>
                      </div>
                    }
                    bgColor={'bg-backgroundColor-white'}
                    accordionIsOpen={true}
                    isActive={true}
                    isFlightCancelled={
                      flight?.cancelled ? 'Cancelled' : 'Active'
                    }
                  >
                    <div className={`bg-backgroundColor-white rounded-sm`}>
                      {/* Header */}
                      <div className="">
                        <PaxPercentageBarSection
                          allocatedPax={flight?.allocatedPax}
                          capacity={flight.maxPax}
                        />
                      </div>

                      {/* Info Grid */}
                      <div className="grid grid-cols-3  sm:grid-cols-5  gap-8 sm:gap-4 text-left mt-4">
                        <div className="flex flex-row items-center">
                          <div>
                            <div className="block dark:hidden">
                              <BalloonIcon />
                            </div>
                            <div className="hidden dark:block">
                              <BalloonIconDark />
                            </div>
                          </div>
                          {Array.isArray(flight?.pilotNameInitials) &&
                          Array.isArray(flight?.pilotNames) ? (
                            flight.pilotNameInitials.map(
                              (initialGroup: string[], index: number) => (
                                <span
                                  key={index}
                                  className="relative group inline-block text-sm ml-[2px] text-text-primary"
                                >
                                  {/* Display Initials */}
                                  {initialGroup.join(', ') || ' '}
                                  {index <
                                    flight.pilotNameInitials.length - 1 && ', '}

                                  {/* Custom Tooltip */}
                                  {flight.pilotNames[index]?.staff_name && (
                                    <div className="absolute z-10 hidden group-hover:block bg-backgroundColor-white text-gray-800 text-sm border border-customBorder-border rounded shadow-lg p-2 w-max top-full left-1/2 transform -translate-x-1/2 mt-1">
                                      <p className="text-text-darkGray">
                                        {flight.pilotNames[index]?.staff_name}
                                      </p>
                                    </div>
                                  )}
                                </span>
                              ),
                            )
                          ) : (
                            <span className="text-sm ml-[2px] text-text-primary">
                              {translate('operation.flightDetails.blankSpace')}
                            </span>
                          )}
                        </div>
                        <div className="flex flex-row items-center">
                          <div>
                            {/* Light mode logic */}
                            <div className="block dark:hidden">
                              {flight?.groundCrewNameInitials.length === 0 ? (
                                <PeopleRedIcon />
                              ) : (
                                <PeopleIcon />
                              )}
                            </div>

                            {/* Dark mode logic */}
                            <div className="hidden dark:block">
                              {flight?.groundCrewNameInitials.length === 0 ? (
                                <PeopleRedIcon />
                              ) : (
                                <PeopleIconDark />
                              )}
                            </div>
                          </div>

                          {Array.isArray(flight?.groundCrewNameInitials) &&
                          Array.isArray(flight?.groundCrewNames) ? (
                            flight.groundCrewNameInitials
                              .flat()
                              .map((initial: string, index: number) => (
                                <span
                                  key={index}
                                  className="relative group inline-block text-sm ml-[2px] text-text-primary cursor"
                                >
                                  {initial || ' '}
                                  {index <
                                    flight.groundCrewNameInitials.flat()
                                      .length -
                                      1 && ', '}

                                  {/* Custom Tooltip */}
                                  {flight.groundCrewNames[index]
                                    ?.staff_name && (
                                    <div className="absolute z-10 hidden group-hover:block bg-backgroundColor-white  text-gray-800 text-sm border border-customBorder-border rounded shadow-lg p-2 w-max top-full left-1/2 transform -translate-x-1/2 mt-1 whitespace-nowrap">
                                      <p className="text-text-darkGray">
                                        {
                                          flight.groundCrewNames[index]
                                            ?.staff_name
                                        }
                                      </p>
                                    </div>
                                  )}
                                </span>
                              ))
                          ) : (
                            <span className="text-sm ml-[2px] text-text-primary">
                              {translate('operation.flightDetails.blankSpace')}
                            </span>
                          )}
                        </div>
                        <div className="flex flex-row items-center">
                          <div>
                            <div className="block dark:hidden">
                              <BusIcons />
                            </div>
                            <div className="hidden dark:block">
                              <BusIconsDark />
                            </div>
                          </div>
                          {Array.isArray(flight?.driverNameInitials) &&
                          Array.isArray(flight?.driverNames) ? (
                            flight.driverNameInitials
                              .flat()
                              .map((initial: string, index: number) => (
                                <span
                                  key={index}
                                  className="relative group inline-block text-sm ml-[2px] text-text-primary cursor"
                                >
                                  {/* Initials display */}
                                  {initial || ' '}
                                  {index <
                                    flight.driverNameInitials.flat().length -
                                      1 && ', '}

                                  {/* Custom Tooltip */}
                                  {flight.driverNames[index]?.staff_name && (
                                    <div className="absolute z-10 hidden group-hover:block bg-backgroundColor-white  text-gray-800 text-sm border border-customBorder-border rounded shadow-lg p-2 w-max top-full left-1/2 transform -translate-x-1/2 mt-1 whitespace-nowrap">
                                      <p className="text-text-darkGray">
                                        {flight.driverNames[index]?.staff_name}
                                      </p>
                                    </div>
                                  )}
                                </span>
                              ))
                          ) : (
                            <span className="text-sm ml-[2px] text-text-primary">
                              {translate('operation.flightDetails.blankSpace')}
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="grid grid-cols-3 sm:grid-cols-5 gap-8 sm:gap-4  text-left mt-6">
                        {flight?.balloonTakeoffTime ? (
                          <div className="flex flex-row items-center">
                            <div>
                              <div className="block dark:hidden">
                                <LaunchingBalloons />
                              </div>
                              <div className="hidden dark:block">
                                <LaunchingBalloonsDark />
                              </div>
                            </div>

                            <span className="text-sm ml-[2px] text-text-primary">
                              {flight?.balloonTakeoffTime}{' '}
                              {translate('operation.flightDetails.am')}
                            </span>
                          </div>
                        ) : (
                          <div className="flex flex-row items-center">
                            <div>
                              <div className="block dark:hidden">
                                <RedLaunchingBalloons />
                              </div>
                              <div className="hidden dark:block">
                                <RedLaunchingBalloons />
                              </div>
                            </div>
                            <span className="text-sm ml-[2px] text-text-primary">
                              {translate(
                                'operation.flightDetails.timeBlankSpace',
                              )}
                            </span>
                          </div>
                        )}
                        {flight?.balloonLandTime ? (
                          <div className="flex flex-row items-center">
                            <div>
                              <div className="block dark:hidden">
                                <LandingBalloon />
                              </div>
                              <div className="hidden dark:block">
                                <LandingBalloonDark />
                              </div>
                            </div>
                            <span className="text-sm ml-[2px] text-text-primary">
                              {flight?.balloonLandTime}{' '}
                              {translate('operation.flightDetails.am')}
                            </span>
                          </div>
                        ) : (
                          <div className="flex flex-row items-center">
                            <div>
                              <div className="block dark:hidden">
                                <RedLandingBalloons />
                              </div>
                              <div className="hidden dark:block">
                                <RedLandingBalloons />
                              </div>
                            </div>
                            <span className="text-sm ml-[2px] text-text-primary">
                              {translate(
                                'operation.flightDetails.timeBlankSpace',
                              )}
                            </span>
                          </div>
                        )}
                        <div className="flex flex-row items-center">
                          <div>
                            <div className="block dark:hidden">
                              <FlightTimeIcon />
                            </div>
                            <div className="hidden dark:block">
                              <FlightTimeIconDark />
                            </div>
                          </div>
                          <span className="text-sm ml-[2px] text-text-primary">
                            {flight?.flightTime ||
                              translate('operation.flightDetails.blankSpace')}
                          </span>
                        </div>
                        {flight?.fuelUsed ? (
                          <div className="flex flex-row items-center">
                            <div>
                              <div className="block dark:hidden">
                                <FuelIcon />
                              </div>
                              <div className="hidden dark:block">
                                <FuelIconDark />
                              </div>
                            </div>

                            <span className="text-sm ml-[2px] text-text-primary">
                              {flight?.fuelUsed ||
                                translate('operation.flightDetails.blankSpace')}
                            </span>
                          </div>
                        ) : (
                          <div className="flex flex-row items-center">
                            <div>
                              <div className="block dark:hidden">
                                <EmptyFuelIcon />
                              </div>
                              <div className="hidden dark:block">
                                <EmptyFuelIcon />
                              </div>
                            </div>
                            <span className="text-sm text-text-primary">
                              {translate(
                                'operation.flightDetails.timeBlankSpace',
                              )}
                            </span>
                          </div>
                        )}
                        <div className="flex flex-row items-center">
                          <div>
                            <div className="block dark:hidden">
                              <AlarmClock />
                            </div>
                            <div className="hidden dark:block">
                              <AlarmClockDark />
                            </div>
                          </div>

                          <span className="text-sm ml-[2px] text-text-primary">
                            {flight?.remainingFlightTime ||
                              translate('operation.flightDetails.blankSpace')}
                          </span>
                        </div>
                      </div>

                      {/* Stats Row */}
                      <div className="grid grid-cols-3  sm:grid-cols-5  gap-8 sm:gap-4 text-left mt-6">
                        <div>
                          <div className="text-sm text-gray-500 text-text-primary">
                            {translate('operation.pax')}
                          </div>
                          <div className="">
                            <span
                              className={`font-bold ${
                                flight?.allocatedPax < flight?.minPax
                                  ? 'text-text-textGreen'
                                  : 'text-text-textRed'
                              }`}
                            >
                              {flight?.allocatedPax}
                            </span>
                            <span className="text-textColor mx-1">/</span>
                            <span className="text-textColor">
                              {flight?.maxPax}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div className="text-sm text-textColorGray">
                            {translate('operation.flightDetails.weight')}
                          </div>
                          <div className="">
                            <span
                              className={`font-bold ${
                                totalAllocatedWeight < flight?.maxBalloonWeight
                                  ? 'text-text-textGreen'
                                  : 'text-text-textRed'
                              }`}
                            >
                              {totalAllocatedWeight}
                            </span>
                            <span className="text-textColor mx-1">/</span>
                            <span className="text-textColorGray">
                              {flight?.maxBalloonWeight}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div className="text-sm text-textColorGray">
                            {translate('operation.flightDetails.pilotHours')}
                          </div>
                          <div className="inline-flex items-center justify-center gap-1">
                            <span className="font-bold text-textColor">
                              {flight?.pilotHours}
                            </span>
                          </div>
                        </div>
                        <div>
                          <div className="text-sm text-textColorGray">
                            {translate('operation.flightDetails.basketTTIS')}
                          </div>
                          <div className="font-bold text-textColor">
                            {flight?.basketWeight}
                          </div>
                        </div>
                        <div>
                          <div className="text-sm text-textColorGray">
                            {translate('operation.flightDetails.envelopeTTIS')}
                          </div>
                          <div className="font-bold text-textColor">
                            {flight?.envelopeWeight}
                          </div>
                        </div>
                      </div>

                      <div className="flex items-center gap-2 pt-2 mt-4">
                        <input
                          type="checkbox"
                          className="h-4 w-4 form-checkbox text-textColor rounded border border-customBorder-border"
                          checked={flight.cancelled}
                          onChange={(e) => handleCheckboxClick(e, flight)}
                        />
                        <label
                          htmlFor="cxld"
                          className="text-sm text-textColorGray"
                        >
                          {translate('operation.flightDetails.cxld')}
                        </label>
                      </div>
                    </div>
                    {modalOpen == true && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 md:p-0">
                        <FlightCancelledModal
                          isOpen={modalOpen}
                          onClose={() => setModalOpen(false)}
                          flight={selectedFlightForReactivation}
                          onConfirm={(data) => {
                            setSelectedFlightForCancel(null);
                            refetchFlights();
                          }}
                        />
                      </div>
                    )}

                    {selectedFlightForCancel?.flightId === flight.flightId && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4 md:p-0">
                        <CancellationForm
                          flightNumber={selectedFlightForCancel.flightId}
                          capacity={selectedFlightForCancel.minPax}
                          cancellationReasons={cancellationReasons}
                          operationBalloonFlightId={
                            selectedFlightForCancel.operationBalloonFlightId
                          }
                          operationBalloonId={
                            selectedFlightForCancel.operationBalloonId
                          }
                          closeModal={() => setSelectedFlightForCancel(null)}
                          onConfirm={(data) => {
                            setSelectedFlightForCancel(null);
                            refetchFlights();
                          }}
                        />
                      </div>
                    )}
                  </Accordion>
                </>
              );
            })}
          </div>
        )}
      </div>
    </Accordion>
  );
};

export default FlightSections;
